import React from 'react'
import {
  LayoutBand,
  H3,
  Overline,
  Subheading,
  Button,
  Separator,
  Grid,
  Cell,
  usePageWidth,
  Image,
  useOverlay,
  DialogOverlay,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import historicalDocumentsImage from './images/historical-documents-image.png'
import AncestorSearch from '../AncestorSearch'

export default function HistoricalDocuments() {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ default: true, md: false })
  const overlay = useOverlay()
  return (
    <LayoutBand marginX="xl">
      <Grid alignItemsY="middle">
        <Image
          src={historicalDocumentsImage}
          alt={t(
            'nlihp.united-states.historical-documents.image-alt',
            'Screenshots of historical documents on FamilySearch'
          )}
          noCrop
          columns={atPageWidth({ default: 12, md: 5, xl: 6 })}
        />
        {!isMobile && (
          <Cell columns={atPageWidth({ default: 0, md: 1 })}>
            <div />
          </Cell>
        )}
        <Cell columns={atPageWidth({ default: 12, md: 6, xl: 4 })}>
          <H3 size="H5">
            <Overline>{t('nlihp.united-states.historical-documents.overline', 'Historical Records')}</Overline>
            {t('nlihp.united-states.historical-documents.heading', 'Search a huge archive of historical documents')}
            <Subheading>
              {t(
                'nlihp.united-states.historical-documents.subheading',
                'We’ve gathered a variety of important documents that recorded important life events. Records can help to tell the story of your family.'
              )}
            </Subheading>
          </H3>
          <Separator size="xs" />
          <Button emphasis="medium" color="gray" linkName="Search all records" onClick={overlay.handleClick}>
            {t('nlihp.united-states.historical-documents.search-all-records', 'Search all records')}
          </Button>
          <Separator size="xs" />
          <Link external to="/search/location/list" isGray wayfinding linkName="Search by Location" target="_blank">
            {t('nlihp.united-states.historical-documents.search-by-location', 'Search by Location')}
          </Link>
        </Cell>
      </Grid>
      <AllRecordsOverlay overlay={overlay} />
    </LayoutBand>
  )
}

function AllRecordsOverlay({ overlay }) {
  const { t } = useTranslation()
  return (
    <DialogOverlay
      {...overlay}
      title={t('nlihp.united-states.all-records-overlay.title', 'Start discovering your family story')}
      subtitle={t(
        'nlihp.united-states.all-records-overlay.subtitle',
        'Search for a specific ancestor in FamilySearch. Even your best guess will do.'
      )}
    >
      <AncestorSearch showLabels columns={1} goToOneSearch goToRecordsTab />
    </DialogOverlay>
  )
}
